import React from 'react';

const AuthUserContext = React.createContext(null);

const UserContext = React.createContext(null);
const CompanyContext = React.createContext(null);
const BranchContext = React.createContext(null);
const AccessContext = React.createContext(null);

const CompanyViewContext = React.createContext(null);
const BranchViewContext = React.createContext(null);
const EmployeeDataViewContext = React.createContext(null);
const SessionDomainContext = React.createContext(null);
const DomainExpirationStatusContext = React.createContext(null);
const FeatureStatusContext = React.createContext(null);



export {AuthUserContext, UserContext, CompanyContext, BranchContext, AccessContext,CompanyViewContext,BranchViewContext,EmployeeDataViewContext,SessionDomainContext,DomainExpirationStatusContext,FeatureStatusContext };